import * as React from 'react'
import { observer } from 'mobx-react'
import { IProduct, ProductCard, productStore } from '../../product'
import { CollectionView } from '../collections.enums'
import { ICollectionLink } from '../collections.interfaces'
import { collectionsStore } from '../collections.store'
import { collectionListStore as store } from './collection-list.store'
import { ReorderCollection } from '../reorder-collection'
import { REORDER_COLLECTION_HANDLE } from '../collections.data'
import { breakpointStore } from '../../../stores'
import { CollectionBanner } from '../collection-banner'
import { isDefaultMenuHandle } from '../../../utils'
import { filterBarStore } from '../filter-bar'
import './collection-list.scss'

const CollectionList: React.FC = observer(() => {
  const myRef = React.useRef<HTMLDivElement>(null)

  const findFirstCollectionHasProduct = (): ICollectionLink => {
    return collectionsStore.links.find((link: ICollectionLink): boolean => {
      if (link.handle === REORDER_COLLECTION_HANDLE) {
        const itemsToDisplay =
          filterBarStore.selectedFilters.length > 0 || filterBarStore.searchTerm
            ? filterBarStore.getFilteredSearchedReorderProducts(collectionsStore.validReorderItems)
            : [...collectionsStore.validReorderItems]

        return itemsToDisplay.length > 0
      }

      return store.displayCollections(link.handle).length > 0
    })
  }

  const renderCollection = (link: ICollectionLink, index: number): JSX.Element => {
    const isReorderCollection = link.handle === REORDER_COLLECTION_HANDLE
    const collectionRef = store.collectionRefs.get(link.handle)

    if (isReorderCollection) {
      return <ReorderCollection collectionRef={collectionRef} index={index} link={link} key='collection-list_reorder-collection' />
    }

    return (
      <div ref={collectionRef} className='collection-list__item' key={`collection-list_${link.handle}_${link.title}`} id={link.handle}>
        {link.banner ? (
          <CollectionBanner handle={link.handle} title={link.title} />
        ) : (
          <h2 className={'collection-list__title'}>{link.title}</h2>
        )}

        <div className='collection-list__products'>
          {store.displayCollections(link.handle).length > 0 ? (
            store
              .displayCollections(link.handle)
              .map((props: IProduct) => <ProductCard key={`collection-list-product__${props.id}`} {...props} />)
          ) : (
            <div className='collection-list__empty' key={`collection-list_${link.handle}_${link.title}__product__empty`}>
              {store.collections(link.handle).length > 0 ? (
                <p>
                  No exact matches.
                  <br />
                  Try changing or removing some of your filters.
                </p>
              ) : (
                <p>0 Products</p>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  const isListView = (): boolean => {
    return productStore.collectionView === CollectionView.LIST
  }

  return findFirstCollectionHasProduct() ? (
    <div className='collection-list'>
      {collectionsStore.links
        .filter((link: ICollectionLink): boolean => {
          const { currentWeeklyMenu } = collectionsStore
          if (currentWeeklyMenu) {
            return link.handle === currentWeeklyMenu.handle
          }
          return isDefaultMenuHandle(link)
        })
        .map((link: ICollectionLink, index: number): JSX.Element => renderCollection(link, index))}
    </div>
  ) : (
    <div className='collection-list no-matches'>
      <p>No products match your search and filters.</p>
    </div>
  )
})

export default CollectionList
